import { render, staticRenderFns } from "./OnboardingMobibNew.vue?vue&type=template&id=9689c36e&"
import script from "./OnboardingMobibNew.vue?vue&type=script&lang=js&"
export * from "./OnboardingMobibNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports